import { MAP_TYPES } from '@deck.gl/carto';

const TRACT_VISUALIZATIONS_SOURCE_ID = 'tractVisualizationsSource';

function source(socioeconomicFactor, tractcode, property = 'year') {
  let data = '';

  if (property === 'year') {
    data = `
      SELECT
        year,
        ${socioeconomicFactor},
        broadband
      FROM
        carto-dw-ac-cn5bemsi.shared.tract_observations
      WHERE
        geoid = (
          SELECT
            geoid
          FROM
            carto-dw-ac-cn5bemsi.shared.tracts
          WHERE
            tractcode = ${tractcode}
        )
      ORDER BY
        year
    `;
  }

  if (property === 'broadband') {
    data = `
      WITH RankedData AS (
        SELECT
            broadband,
            ${socioeconomicFactor},
            ROW_NUMBER() OVER (PARTITION BY CAST(broadband AS INTEGER) ORDER BY year DESC) AS RowNum
        FROM
          carto-dw-ac-cn5bemsi.shared.tract_observations
        WHERE
          geoid = (
            SELECT
              geoid
            FROM
              carto-dw-ac-cn5bemsi.shared.tracts
            WHERE
            tractcode = ${tractcode}
          )
        )
      SELECT
        broadband,
        ${socioeconomicFactor}
      FROM
        RankedData
      WHERE
        RowNum = 1
      ORDER BY
        broadband,
        ${socioeconomicFactor} ASC
    `;
  }

  return {
    id: TRACT_VISUALIZATIONS_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data,
    queryParameters: {
      socioeconomicFactor,
      tractcode,
      property,
    },
  };
}

export default source;
